export default __webpack_public_path__ + "static/media/Indore.33b6f6b8.png";